// Статуси по машинах

export const statusesCar = [
  { status: "all", label: "Всі авто" },
  { status: "new", label: "Нові" },
  { status: "diagnostic", label: "Діагностика" },
  { status: "repair", label: "Ремонт" },
  { status: "completed", label: "Завершено" },
  { status: "returned", label: "Видано" },
];

// Статуси по клієнтах

export const statusesCommunications = [
  { status: "ALL", label: "Всі" },
  { status: "NEW", label: "Нові" },
  { status: "CLIENT", label: "Клієнти" },
  { status: "LOST", label: "Втрачено" },
  { status: "APPOINTMENT", label: "Запис" },
];

// Статуси для архіву

export const statusesArchive = [
  { reason_description: "all", label: "Всі авто" },
  { reason_description: "рекомендації", label: "Рекомендації" },
  { reason_description: "співробітник", label: "Cпівробітник" },
  { reason_description: "випадковий", label: "Випадковий" },
  { reason_description: "дубль", label: "Дубль" },
  { reason_description: "відмова", label: "Відмова" },
  { reason_description: "не_приїхав", label: "Не приїхав" },
  { reason_description: "рейтинг", label: "Рейтинг" },
  { reason_description: "не_допомогли", label: "Не допомогли" },
];

// Статуси для редагування в архіві
export const statusesArchiveEdit = [
  { reason_description: "дубль", label: "Дубль", reason_add: "1" },
  {
    reason_description: "співробітник",
    label: "Cпівробітник",
    reason_add: "2",
  },
  { reason_description: "випадковий", label: "Випадковий", reason_add: "3" },
  { reason_description: "відмова", label: "Відмова", reason_add: "4" },
  { reason_description: "не_приїхав", label: "Не приїхав", reason_add: "5" },
  { reason_description: "рейтинг", label: "Рейтинг", reason_add: "6" },
  {
    reason_description: "не_допомогли",
    label: "Не допомогли",
    reason_add: "7",
  },
];
// Статуси для редагування в архіві
// export const statusesArchiveEdit = [
//   { reason_description: "дубль", label: "Дубль" },
//   { reason_description: "співробітник", label: "Cпівробітник" },
//   { reason_description: "випадковий", label: "Випадковий" },
//   { reason_description: "відмова", label: "Відмова" },
//   { reason_description: "не_приїхав", label: "Не приїхав" },
//   { reason_description: "рейтинг", label: "Рейтинг" },
//   { reason_description: "не_допомогли", label: "Не допомогли" },
// ];


// Заголовки срм компоненті

export const statusMapping = {
  booked: "Запис",
  new: "Машинозаїзди",
  diagnostic: "Діагностика",
  repair: "Ремонт",
};

// пробні статуси для компоненту зв'язку (клієнти)

export const statusesInConnections = {
  missing: "Втрачено",
  diagnostic: "Діагностика",
  repair: "Ремонт",
  appointment: "Запис",
};

// пробний масив для аудіоплеера

export const summary =
  "Привіт! Мене звати [Ім'я], і я хочу записатися на ремонт свого автомобіля. У мене[марка і модель авто], і після нещодавньої аварії потрібен огляд і ремонт кузова, зокрема вирівнювання геометрії та заміна пошкоджених деталей.Також цікавить діагностика стану автомобіля після ремонту.Чи є у вас вільні дати на цьому тижні, щоб я міг під'їхати на оцінку? Дякую!";

export const messages = [
  {
    orClientMsg: true,
    time: "00:00",
    message:
      "Доброго дня, ще раз заставлю. Скажіть, будь ласка, якщо я щось відвіду, я вам дзвоню, у мене нашовання блок АБС. Може хтось подивитися, це він чи не він?",
  },
  {
    orClientMsg: false,
    time: "00:15",
    message:
      "Можемо тільки з наступної середи, тому що електрик у нас відпустив.",
  },
  {
    orClientMsg: true,
    time: "00:00",
    message:
      "Доброго дня, ще раз заставлю. Скажіть, будь ласка, якщо я щось відвіду, я вам дзвоню, у мене нашовання блок АБС. Може хтось подивитися, це він чи не він?",
  },
  {
    orClientMsg: false,
    time: "00:15",
    message:
      "Можемо тільки з наступної середи, тому що електрик у нас відпустив.",
  },
  {
    orClientMsg: true,
    time: "00:00",
    message:
      "Доброго дня, ще раз заставлю. Скажіть, будь ласка, якщо я щось відвіду, я вам дзвоню, у мене нашовання блок АБС. Може хтось подивитися, це він чи не він?",
  },
  {
    orClientMsg: false,
    time: "00:15",
    message:
      "Можемо тільки з наступної середи, тому що електрик у нас відпустив.",
  },
];

// Лейбл для модлаки - налаштування видимості

export const labelNamesInModal = {
  name: "Ім'я",
  // rating: "Рейтинг",
  carNum: "Номер машини",
  carModelYear: "Марка-модель",
  vin: "VIN",
  date: "Дата",
  time: "Час",
  photo: "Фото",
  totalPrice: "Загальна сума",
  normHours: "Нормо-години",
  phoneNumber: "Телефон",
  prePayment: "Передплата",
};

// Лейбли для сторінки звернень

export const labelNamesDashBoard = {
  sales: "Продажи",
  costs: "Витрати",
  profit: "Прибуток",
  leads: "Ліди",
  newСlients: "Нові клієнти",
};

// Лейбл для архіву

export const labelNamesInArchive = {
  photo: "Фото",
  name: "Ім'я",
  carNum: "Номер машини",
  time: "Час",
  status: "Статус",
  // reasonRegistration: "Причина запису",
  reasonArchived: "Причина архіву",
  btn: "Налаштування",
  timeOnPost: "Час на посту",
};

// Лейбл для CRM - налаштування видимості

export const labelNamesInCrm = {
  name: "Ім'я",
  // rating: "Рейтинг",
  carNum: "Номер машини",
  carModelYear: "Марка-модель",
  vin: "VIN",
  mileage: "Пробіг",
  time: "Час",
  photo: "Фото",
  totalPrice: "Загальна сума",
  phoneNumber: "Телефон",
  prePayment: "Передплата",
};

// Лейбл для секції постачальників - налаштування видимості

export const labelNamesDistributorSection = {
  date: "Дата",
  quantity: "Кількість",
  code: "Артикул",
  brand: "Бренд",
  nomenclature: "Номенклатура",
  purchasePrice: "Ціна закупки",
  purchaseAmount: "Сума закупки",
  saleAmount: "Сума продажу",
  profit: "Прибуток",
  percent: "% прибутку",
};

// Лейбл для секції накладних - налаштування видимості

export const labelNamesInvoices = {
  diagnostics: "Діагностика",
  KP: "КП",
  reserved: "Замовлення",
  income: "Надходження",
  repair: "Ремонт",
  soldOut: "Продажі",
  returned: "Повернення",
  moved: "Переміщення",
  revaluation: "Переоцінка",
  inventory: "Інвентаризація",
  writeOff: "Списання",
  spent: "Витрати",
};

// Прикожу назви в компонентів до назв в стані заголовки

export const categoryNameMapping = {
  Діагностика: "diagnostics",
  КП: "KP",
  Замовлення: "reserved",
  Надходження: "income",
  Ремонт: "repair",
  Продажі: "soldOut",
  Повернення: "returned",
  Переміщення: "moved",
  Переоцінка: "revaluation",
  Інвентаризація: "inventory",
  Списання: "writeOff",
  Витрати: "spent",
};

// Лейбл для секції облік(клієнти у роботі) - налаштування видимості

export const labelNamesClientsInWork = {
  photo: "Фото",
  appeal: "Звернення",
  diagnostics: "Діагностика",
  KP: "КП",
  prePayment: "Аванс",
  order: "Замовлення",
  provider: "Постачальник",
  repair: "Ремонт",
  totalAmount: "Загальна сума",
  notification: "Сповіщення",
};

export const categoryIdClients = {
  0: "photo",
  1: "appeal",
  2: "diagnostics",
  3: "KP",
  4: "prePayment",
  5: "order",
  6: "provider",
  7: "repair",
  8: "totalAmount",
  9: "notification",
};

// Лейбл для секції облік(загальний список клієнтів) - налаштування видимості

export const labelNamesAllClients = {
  appeal: "Звернення",
  repair: "Ремонт",
  averageCheck: "Середній чек",
  paydesk: "Каса",
  workPayment: "Оплата за роботу",
  salaryMechanics: "ЗП механіка",
  spareParts: "Запчастини",
  markUp: "Націнка",
  salaryManager: "ЗП Менеджер",
  salaryAdmin: "ЗП Адмін",
  coefficient: "Коефіцієнт",
  NG: "НГ",
  profit: "Прибуток",
  percent: "% прибутку",
};

export const labelNamesRecomendations = {
  name: "Ім'я",
  phoneNumber: "Телефон",
  carModelYear: "Марка-модель",
  timeForTO: "Час до ТО",
  rating: "Рейтинг",
  photo: "Фото",
  carNum: "Номер машини",
  mileage: "Пробіг",
  KP: "КП",
  totalPrice: "Загальна сума",
};

// Для PDF Постачальники дані

export const dataArrDistributors = [
  {
    id: 1,
    orderDate: "02.02",
    distributorLogo: "",
    distributorName: "GRS PARTS",
    invoiceSum: "4610",
    delivered: true,
    deliveryDate: "03.02",
    carPartsQuantity: "7",
    profit: "1780",
    percent: "31",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "5800",
    carParts: [
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        salesAmount: 4300,
        purchaseAmount: "3000",
        salesPercent: "32",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "33",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: "!",
        salesPercent: "-100%",
      },
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "10",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: "!",
        salesPercent: "-100%",
      },
    ],
  },
  {
    id: 2,
    orderDate: "02.02",
    distributorLogo: "",
    distributorName: "Elit.ua",
    invoiceSum: "5200",
    delivered: true,
    deliveryDate: "01.02",
    carPartsQuantity: "1",
    profit: "2200",
    percent: "37",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "6000",
    carParts: [
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "31",
      },
    ],
  },
  {
    id: 3,
    orderDate: "02.02",
    distributorLogo: "",
    distributorName: "GRS PARTS",
    invoiceSum: "4610",
    delivered: true,
    deliveryDate: "03.02",
    carPartsQuantity: "17",
    profit: "8000",
    percent: "31",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "5800",
    carParts: [
      {
        quantity: 5,
        code: "214197",
        brandName: "HYUNDAI",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "HYUNDAI",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "5",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "HYUNDAI",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "22",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "25",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
    ],
  },
  {
    id: 4,
    orderDate: "03.02",
    distributorLogo: "",
    distributorName: "Elit.ua",
    invoiceSum: "5200",
    delivered: true,
    deliveryDate: "04.02",
    carPartsQuantity: "5",
    profit: "5000",
    percent: "37",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "6000",
    carParts: [
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "42",
      },
    ],
  },
  {
    id: 1,
    orderDate: "03.02",
    distributorLogo: "",
    distributorName: "GRS PARTS",
    invoiceSum: "4610",
    delivered: true,
    deliveryDate: "04.02",
    carPartsQuantity: "7",
    profit: "1780",
    percent: "31",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "5800",
    carParts: [
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        salesAmount: 4300,
        purchaseAmount: "3000",
        salesPercent: "32",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "33",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "10",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
    ],
  },
  {
    id: 2,
    orderDate: "03.02",
    distributorLogo: "",
    distributorName: "Elit.ua",
    invoiceSum: "5200",
    delivered: true,
    deliveryDate: "05.02",
    carPartsQuantity: "1",
    profit: "2200",
    percent: "37",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "6000",
    carParts: [
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "31",
      },
    ],
  },
  {
    id: 3,
    orderDate: "03.02",
    distributorLogo: "",
    distributorName: "GRS PARTS",
    invoiceSum: "4610",
    delivered: true,
    deliveryDate: "05.02",
    carPartsQuantity: "17",
    profit: "8000",
    percent: "31",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "5800",
    carParts: [
      {
        quantity: 5,
        code: "214197",
        brandName: "HYUNDAI",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "HYUNDAI",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "5",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "HYUNDAI",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
      {
        quantity: 5,
        code: "214197",
        brandName: "MAZDA",
        carPartsName: "Олива MAZDA ORIGINAL",
        price: 600,
        purchaseAmount: "3000",
        salesAmount: 4300,
        salesPercent: "22",
      },
      {
        quantity: 1,
        code: "FZ0121500",
        brandName: "MAZDA",
        carPartsName: "Фильтр масляный АКПП",
        price: 1020,
        purchaseAmount: "1020",
        salesAmount: 1500,
        salesPercent: "25",
      },
      {
        quantity: 1,
        code: "KC 83D",
        brandName: "Knecht/Mah",
        carPartsName: "ФИЛЬТР ТОПЛИВА",
        price: 590,
        purchaseAmount: "590",
        salesAmount: null,
        salesPercent: null,
      },
    ],
  },
  {
    id: 4,
    orderDate: "03.02",
    distributorLogo: "",
    distributorName: "Elit.ua",
    invoiceSum: "5200",
    delivered: true,
    deliveryDate: "04.02",
    carPartsQuantity: "5",
    profit: "5000",
    percent: "37",
    carImg: "",
    carNumber: "CA 6864 CO",
    salesAmount: "6000",
    carParts: [
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "31",
      },
      {
        quantity: 1,
        code: "515483232",
        brandName: "MAZDA",
        carPartsName: "Важіль валу перемикання передач МКПП",
        price: "6000",
        purchaseAmount: "6000",
        salesAmount: "8300",
        salesPercent: "42",
      },
    ],
  },
];

export const carsInRecomendations = [
  // {
  //   id: 1968,
  //   client_id: null,
  //   status: "ТО",
  //   plate: "СА3690ІР",
  //   name: "Іван Петренко",
  //   car_id: 6201,
  //   date: "2025-01-16T08:04:35",
  //   phone: "0937893480",
  //   auto: "Mersedes",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СА3690ІР.jpg",
  //   client_rating: "Немає рейтингу",
  // },
  // {
  //   id: 1969,
  //   client_id: null,
  //   status: "ХОДОВА",
  //   plate: "СА4924ІС",
  //   name: "Іван Макаренко",
  //   car_id: 6202,
  //   date: "2025-01-16T09:02:49",
  //   auto: "Kia",
  //   phone: "0934567812",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СА4924ІС.jpg",
  //   client_rating: "Немає рейтингу",
  // },
  // {
  //   id: 1970,
  //   client_id: null,
  //   status: "ПОВТОРНИЙ ЗАЇЗД",
  //   plate: "СН6757ІІ",
  //   name: "Станіслав Макаренко",
  //   car_id: 6204,
  //   date: "2025-01-17T12:46:06",
  //   auto: "Ford Focuse",
  //   phone: "0668901245",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СН6757ІІ.jpg",
  //   client_name: "Неизвестный клиент",
  //   client_rating: "Немає рейтингу",
  // },
  // {
  //   id: 1971,
  //   client_id: null,
  //   status: "АКЦІЯ RENAULT",
  //   plate: "СА4500ВН",
  //   name: "Ігор Крутий",
  //   car_id: 6205,
  //   date: "2025-01-17T12:57:59",
  //   auto: "Aveo",
  //   phone: "0679035681",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СА4500ВН.jpg",
  //   client_name: "Неизвестный клиент",
  //   client_rating: "Немає рейтингу",
  //   percent: 37,
  // },
  // {
  //   id: 1972,
  //   client_id: null,
  //   status: "СЕЗОННА АКЦІЯ",
  //   plate: "СН8757ІІ",
  //   name: null,
  //   car_id: 6206,
  //   date: "2025-01-18T15:43:37",
  //   phone: "0509453781",
  //   services: null,
  //   auto: "Volkswagen Tiguan None",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СН8757ІІ.jpg",
  //   client_name: "Неизвестный клиент",
  //   client_rating: "Немає рейтингу",
  //   percent: 15,
  // },
  // {
  //   id: 1973,
  //   client_id: null,
  //   status: "АКЦІЯ FORD",
  //   plate: "СН6957ІІ",
  //   name: null,
  //   car_id: 6207,
  //   date: "2025-01-19T17:32:57",
  //   phone: "0673580091",
  //   auto: "Volkswagen Tiguan None",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СН6957ІІ.jpg",
  //   client_name: "Неизвестный клиент",
  //   client_rating: "Немає рейтингу",
  //   percent: 23,
  // },
  // {
  //   id: 1974,
  //   client_id: null,
  //   status: "АКЦІЯ FORD",
  //   plate: "КА1234АС",
  //   name: "Олег Семенов",
  //   car_id: 6208,
  //   date: "2025-01-16T09:15:00",
  //   auto: "Toyota Camry",
  //   phone: "0501234567",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/КА1234АС.jpg",
  //   client_rating: "Немає рейтингу",
  //   percent: 60,
  // },
  // {
  //   id: 1975,
  //   client_id: null,
  //   status: "ТО",
  //   plate: "ВС5678ЕР",
  //   name: "Марія Коваль",
  //   car_id: 6209,
  //   date: "2025-01-17T11:45:30",
  //   auto: "Nissan Qashqai",
  //   phone: "0976543210",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/ВС5678ЕР.jpg",
  //   client_rating: "Немає рейтингу",
  //   percent: 45,
  // },
  // {
  //   id: 1976,
  //   client_id: null,
  //   status: "ТО",
  //   plate: "СВ9876ІТ",
  //   name: "Павло Іваненко",
  //   car_id: 6210,
  //   date: "2025-01-18T14:20:45",
  //   auto: "Honda CR-V",
  //   phone: "0931122334",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СВ9876ІТ.jpg",
  //   client_rating: "Немає рейтингу",
  // },
  // {
  //   id: 1977,
  //   client_id: null,
  //   status: "ТО",
  //   plate: "СВ9876ІТ",
  //   name: "Павло Іваненко",
  //   car_id: 6210,
  //   date: "2025-01-16T14:20:45",
  //   auto: "Honda CR-V",
  //   phone: "0931122334",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СВ9876ІТ.jpg",
  //   client_rating: "Немає рейтингу",
  // },
  // {
  //   id: 1978,
  //   client_id: null,
  //   status: "ТО",
  //   plate: "СВ9876ІТ",
  //   name: "Павло Іваненко",
  //   car_id: 6210,
  //   date: "2025-01-17T14:20:45",
  //   auto: "Honda CR-V",
  //   phone: "0931122334",
  //   company_id: 1,
  //   photo_url: "https://api.assist.cam/auto/СВ9876ІТ.jpg",
  //   client_rating: "Немає рейтингу",
  // },
];

// Тимчасові дані для таблиці продажу
export const dataSale = {
  timestamp: "2025-04-18T12:56:31.094000",
  _id: "68024bff86145e9eb272227d",
  items: [
    {
      code: "A001",
      brand: "Bosch",
      name: "Свічка запалювання",
      location_id: "Склад 1",
      quantity: 10,
      purchase_price: 100.5,
      sale_price: 130.0,
      total_sale_price: 1300.0,
      markup: 29.35,
    },
    {
      code: "A0014",
      brand: "Bosch",
      name: "Свічка запалювання",
      location_id: "Склад 1",
      quantity: 10,
      purchase_price: 100.5,
      sale_price: 130.0,
      total_sale_price: 1300.0,
      markup: 29.35,
    },
    {
      code: "A003",
      brand: "Bosch",
      name: "Свічка запалювання",
      location_id: "Склад 1",
      quantity: 10,
      purchase_price: 100.5,
      sale_price: 130.0,
      total_sale_price: 1300.0,
      markup: 29.35,
    },
    {
      code: "A002",
      brand: "Bosch",
      name: "Свічка запалювання",
      location_id: "Склад 1",
      quantity: 10,
      purchase_price: 100.5,
      sale_price: 130.0,
      total_sale_price: 1300.0,
      markup: 29.35,
    },
    {
      code: "B123",
      brand: "Valeo",
      name: "Фільтр повітряний",
      location_id: "Склад 2",
      quantity: 5,
      purchase_price: 80.0,
      sale_price: 110.0,
      total_sale_price: 550.0,
      markup: 37.5,
    },
    {
      code: "C789",
      brand: "Lemförder",
      name: "Амортизатор передній",
      location_id: "Склад 1",
      quantity: 2,
      purchase_price: 450.0,
      sale_price: 600.0,
      total_sale_price: 1200.0,
      markup: 33.33,
    },
    {
      code: "D456",
      brand: "MANN-FILTER",
      name: "Масляний фільтр",
      location_id: "Склад 3",
      quantity: 15,
      purchase_price: 65.0,
      sale_price: 90.0,
      total_sale_price: 1350.0,
      markup: 38.46,
    },
    {
      code: "E321",
      brand: "Febi",
      name: "Кульова опора",
      location_id: "Склад 2",
      quantity: 4,
      purchase_price: 210.0,
      sale_price: 280.0,
      total_sale_price: 1120.0,
      markup: 33.33,
    },
    {
      code: "F888",
      brand: "Brembo",
      name: "Гальмівний диск",
      location_id: "Склад 1",
      quantity: 6,
      purchase_price: 320.0,
      sale_price: 450.0,
      total_sale_price: 2700.0,
      markup: 40.63,
    },
    // {
    //   code: "G909",
    //   brand: "SKF",
    //   name: "Підшипник ступиці",
    //   location_id: "Склад 4",
    //   quantity: 3,
    //   purchase_price: 375.0,
    //   sale_price: 500.0,
    //   total_sale_price: 1500.0,
    //   markup: 33.33,
    // },
    // {
    //   code: "H111",
    //   brand: "TRW",
    //   name: "Гальмівні колодки",
    //   location_id: "Склад 3",
    //   quantity: 8,
    //   purchase_price: 150.0,
    //   sale_price: 190.0,
    //   total_sale_price: 1520.0,
    //   markup: 26.67,
    // },
    // {
    //   code: "I222",
    //   brand: "KYB",
    //   name: "Опора амортизатора",
    //   location_id: "Склад 2",
    //   quantity: 4,
    //   purchase_price: 200.0,
    //   sale_price: 270.0,
    //   total_sale_price: 1080.0,
    //   markup: 35.0,
    // },
    // {
    //   code: "J333",
    //   brand: "Sachs",
    //   name: "Зчеплення",
    //   location_id: "Склад 1",
    //   quantity: 1,
    //   purchase_price: 1200.0,
    //   sale_price: 1550.0,
    //   total_sale_price: 1550.0,
    //   markup: 29.17,
    // },
  ],
};
